<template>
  <div>
    <h4>
      <img
        width="30"
        height="30"
        class="cursor-pointer mr-4 float-right"
        @click="goBack()"
        src="https://cdn.howuku.com/images/close-icon.png"
      />
    </h4>
    <div style="padding: 40px; padding-right: 0px; margin-top: 20px">
      <div id="edit-form" v-bind:key="refresher">
        <div class="col-md-12 mx-auto">
          <div class="row">
            <div class="col-md-12 col-xs-12 mx-auto">
              <h3 v-translate class="mb-4">Integration Tools</h3>
              <div class="mt-3">
                Connect with our ready integration tools to automate your
                workflow
              </div>
              <br />
              <div class="form-group row" style="margin-right: -40px">
                <div class="col-sm-9">
                  <img
                    src="../assets/img/slack.png"
                    class="img-fluid float-left mr-3"
                    style="margin-left: 8px; padding-right: 4px;"
                    width="60"
                  />
                  <div class="mt-2">
                    <b style="line-height: 1.5" for="inputWebsite" v-translate
                      >Slack</b
                    >
                    <div>
                      {{ t("Setup automatic workflow for other apps") }}
                    </div>
                    <small class="text-muted" v-if="this.isHowuku">
                      <img
                        src="https://media.istockphoto.com/vectors/question-mark-in-blue-circle-vector-icon-vector-id911898690?k=20&m=911898690&s=170667a&w=0&h=1p_LAoGjqTsr4jFkpo-qqas-yTl37jN_9GHG4RcsLXc="
                        class="img-fluid mr-1"
                        width="12"
                      />
                      <a
                        href="https://howuku.freshdesk.com/support/solutions/articles/150000072543-connect-howuku-with-slack"
                        target="_blank"
                      >
                        <b class="text-primary"> Learn more to connect Howuku with Slack </b>
                      </a>
                    </small>
                  </div>
                </div>
                <button 
                  class="btn btn-first mx-2 btn-adjust" 
                  @click="authSlackWindow()" 
                  :disabled="!isAdmin"
                  v-if="!slackConnected"
                >
                  Connect
                </button>
                <button class="btn btn-third mx-2 btn-adjust disconnect" @click="disconnectSlack()" v-else>
                  Disconnect
                </button>
              </div>              
              <div class="form-group row">
                <div class="col-sm-10">
                  <img
                    src="https://assets-us-01.kc-usercontent.com/4ec262a7-3d6c-008c-aa10-1e6ffc6c2e14/56e70d9c-c974-446a-9002-b3a3902b48b8/zapier_integration.png"
                    class="img-fluid float-left mr-2"
                    width="70"
                  />
                  <div class="mt-2">
                    <b style="line-height: 1.5" for="inputWebsite" v-translate
                      >Zapier</b
                    >
                    <div>
                      {{ t("Setup automatic workflow for other apps") }}
                    </div>
                    <small class="text-muted" v-if="this.isHowuku">
                      <img
                        src="https://media.istockphoto.com/vectors/question-mark-in-blue-circle-vector-icon-vector-id911898690?k=20&m=911898690&s=170667a&w=0&h=1p_LAoGjqTsr4jFkpo-qqas-yTl37jN_9GHG4RcsLXc="
                        class="img-fluid mr-1"
                        width="12"
                      />
                      <a
                        href="https://howuku.freshdesk.com/support/solutions/articles/150000072540-connect-howuku-with-zapier"
                        target="_blank"
                      >
                        <b class="text-primary"> Learn more to connect Howuku with Zapier </b>
                      </a>
                    </small>
                  </div>
                </div>
                <toggle-button
                  class="mt-4 float-right"
                  v-model="zapierFlag"
                  color="#2eb15a"
                  :labels="true"
                  @change="updateFlag()"
                  :disabled="!isAdmin"
                />
              </div>
              <div class="form-group row">
                <div class="col-sm-10">
                  <img
                    src="../assets/img/httpwebhook.png"
                    class="img-fluid float-left mr-3"
                    style="margin-left: 4px"
                    width="60"
                  />
                  <div class="mt-2">
                    <b style="line-height: 1.5" for="inputWebsite" v-translate
                      >HTTP Webhook</b
                    >
                    <div>
                      {{ t("Setup automatic workflow for other apps") }}
                    </div>
                    <small class="text-muted" v-if="this.isHowuku">
                      <img
                        src="https://media.istockphoto.com/vectors/question-mark-in-blue-circle-vector-icon-vector-id911898690?k=20&m=911898690&s=170667a&w=0&h=1p_LAoGjqTsr4jFkpo-qqas-yTl37jN_9GHG4RcsLXc="
                        class="img-fluid mr-1"
                        width="12"
                      />
                      <a
                        href="https://howuku.freshdesk.com/support/solutions/articles/150000072542-connect-howuku-with-http-webhook"
                        target="_blank"
                      >
                        <b class="text-primary"> Learn more to connect Howuku with HTTP webhook </b>
                      </a>
                    </small>
                  </div>
                </div>
                <toggle-button
                  class="mt-4 float-right"
                  v-model="pabblyFlag"
                  color="#2eb15a"
                  :labels="true"
                  @change="updateFlag()"
                  :disabled="!isAdmin"
                />
              </div>
              <div class="form-group row" style="margin-right: -40px">
                <div class="col-sm-9">
                  <img
                    src="https://seeklogo.com/images/S/segment-logo-FCBB33F58E-seeklogo.com.png"
                    class="float-left mr-3"
                    style="margin-left: 8px; padding-right: 4px;"
                    width="60"
                    height="56 !important"
                    maxWidth="100%"
                  />
                  <div class="mt-2">
                    <b style="line-height: 1.5" for="inputWebsite" v-translate
                      >Segment</b
                    >
                    <div>
                      {{ t("Setup automatic workflow for other apps") }}
                    </div>
                    <small class="text-muted" v-if="this.isHowuku">
                      <img
                        src="https://media.istockphoto.com/vectors/question-mark-in-blue-circle-vector-icon-vector-id911898690?k=20&m=911898690&s=170667a&w=0&h=1p_LAoGjqTsr4jFkpo-qqas-yTl37jN_9GHG4RcsLXc="
                        class="img-fluid mr-1"
                        width="12"
                      />
                      <a
                        href="https://howuku.freshdesk.com/support/solutions/articles/150000072544-connect-howuku-with-segment"
                        target="_blank"
                      >
                        <b class="text-primary"> Learn more to connect Howuku with Segment </b>
                      </a>
                    </small>
                  </div>
                </div>
                <button 
                  class="btn btn-first mx-2 btn-adjust webhook" 
                  @click="copyWebhook()" 
                  :disabled="!isAdmin"
                >
                  Copy Webhook
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['editId', 'redirectPage'],
  data: function () {
    return {
      isHowuku: false,
      widgets: {},
      refresher: 0,
      zapierFlag: false,
      pabblyFlag: false,
      slackFlag: false,
      slackConnected: false,
      slackUrl: `https://slack.com/oauth/v2/authorize?scope=chat%3Awrite%2Cchat%3Awrite.public%2Cchannels%3Aread&user_scope=&redirect_uri=https%3A%2F%2Fapi.mida.so%2Fslack%2Fcallback&client_id=3302183378370.4348252204821&state=${this.editId}%3B${this.redirectPage}%3B${this.$isOptimize}`,
      isAdmin: this.$session.get('role') === 0 || this.$session.get('role') === 1
    }
  },
  mounted() {
    this.getFlag()
    this.isHowuku =
      window.location.host === 'app.howuku.com' ||
      window.location.host.includes('localhost')
  },
  methods: {
    goBack() {
      this.$modal.hide('modal-integration')
    },
    getFlag() {
      this.$http
        .post(process.env.API_ENDPOINT + '/getWidgets', {
          widget_id: this.editId
        })
        .then((response) => {
          let data = response.data[0]

          this.zapierFlag = Number(data.widget_zapier_flag)
          this.pabblyFlag = Number(data.widget_pabbly_flag)
          this.slackFlag = Number(data.widget_slack_flag)
          this.slackConnected = data.slack_secret && true;
          this.refresher++
        })
    },
    updateFlag() {
      let option = {
        widget_id: this.editId,
        widget_zapier_flag: Number(this.zapierFlag),
        widget_pabbly_flag: Number(this.pabblyFlag),
        widget_slack_flag: Number(this.slackFlag)
      }

      this.$http
        .post(process.env.API_ENDPOINT + '/saveWidget', option)
        .then((response) => {
          this.$awn.success('Integration tools updated', {
            position: 'bottom-right',
            maxNotifications: 1
          })
        })
    },
    authSlackWindow() {
      location.replace(this.slackUrl);
    },
    disconnectSlack() {
      this.$http
        .post(process.env.API_ENDPOINT + '/slack/disconnect', {widget_id: this.editId})
        .then((response) => {
          this.$awn.success('Slack disconnected', {
            position: 'bottom-right',
            maxNotifications: 1
          })
          this.slackFlag = false;
          this.slackConnected = false;
        })
    },
    copyWebhook() {
      navigator.clipboard.writeText(`https://api.mida.so/segment/${this.$session.get('secretkey')}`);
      this.$awn.success('Webhook URL copied', {
        position: 'bottom-right',
        maxNotifications: 1
      })
    }
  }
}
</script>
<style>
  .btn-adjust {
    height: min-content;
    padding: 8px 16px;
    margin-top: auto;
    margin-bottom: auto
  }

  .disconnect {
    margin-left: -10px !important; 
  }

  .webhook {
    margin-left: -35px !important; 
  }
</style>



// WEBPACK FOOTER //
// src/components/IntegrationTools.vue